import { readAllData, STORES } from "utility"

export async function getPrestationsOffline({ filters = {} }) {
  let data = await readAllData(STORES.PRESTATIONS)

  if (filters.name) {
    const search = filters.name.toLowerCase()
    data = data.filter((p) => p.name?.toLowerCase().includes(search))
  }

  return data
}
